import React from "react";

export const DonationsIcon = () => {
  return (
    <svg
      width="61"
      height="62"
      viewBox="0 0 61 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_496_1330)">
        <g clipPath="url(#clip1_496_1330)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.6637 49.9487C16.1735 48.1728 8.17188 39.0321 8.17188 28.0378C8.17188 15.7729 18.1294 5.81543 30.3943 5.81543C42.6592 5.81543 52.6166 15.7729 52.6166 28.0378C52.6166 39.0321 44.6151 48.1728 34.1249 49.9487L30.3943 58.3416L26.6637 49.9487ZM30.3943 19.9574C34.854 19.9574 38.4758 23.5781 38.4758 28.0378C38.4758 32.4974 34.854 36.1194 30.3943 36.1194C25.9346 36.1194 22.3128 32.4974 22.3128 28.0378C22.3128 23.5781 25.9346 19.9574 30.3943 19.9574Z"
            fill="#E4E9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.9492 23.9104C36.7562 25.032 37.2325 26.4086 37.2325 27.8955C37.2325 31.6668 34.1697 34.7296 30.3985 34.7296C26.6272 34.7296 23.5644 31.6668 23.5644 27.8955C23.5644 24.1243 26.6272 21.0615 30.3985 21.0615C31.5054 21.0615 32.5513 21.3254 33.4759 21.7936C34.0918 22.1052 34.8459 21.8583 35.1576 21.2416C35.4692 20.6257 35.2223 19.8723 34.6056 19.5607C33.3414 18.9205 31.9118 18.5596 30.3985 18.5596C25.2454 18.5596 21.0625 22.7425 21.0625 27.8955C21.0625 33.0486 25.2454 37.2315 30.3985 37.2315C35.5515 37.2315 39.7344 33.0486 39.7344 27.8955C39.7344 25.8633 39.084 23.9817 37.98 22.4485C37.5765 21.8876 36.7937 21.7605 36.2336 22.164C35.6728 22.5675 35.5457 23.3496 35.9492 23.9104Z"
            fill="#3C51A0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4332 38.9098C10.3654 35.6606 9.16791 31.8056 9.16791 27.674C9.16791 16.105 18.562 6.71088 30.131 6.71088C41.7 6.71088 51.0942 16.105 51.0942 27.674C51.0942 38.0455 43.5478 46.6683 33.6508 48.3424C33.2389 48.4129 32.8875 48.6837 32.7179 49.0672L30.131 54.8871L27.5442 49.0672C27.3746 48.6837 27.0232 48.4129 26.6112 48.3424C23.2651 47.7769 20.1897 46.4159 17.5827 44.4632C17.0314 44.0491 16.2458 44.1623 15.8319 44.7136C15.4199 45.2668 15.531 46.0503 16.0843 46.4643C18.8286 48.52 22.0394 49.9902 25.5289 50.6847C25.5269 50.6847 28.9881 58.4715 28.9881 58.4715C29.19 58.9239 29.6363 59.2146 30.131 59.2146C30.6258 59.2146 31.0721 58.9239 31.274 58.4715L34.7352 50.6847C45.4823 48.5443 53.5941 39.0491 53.5941 27.674C53.5941 14.7237 43.0813 4.21094 30.131 4.21094C17.1808 4.21094 6.66797 14.7237 6.66797 27.674C6.66797 32.3004 8.0108 36.6159 10.325 40.2528C10.6965 40.8344 11.47 41.0059 12.0516 40.6364C12.6331 40.2648 12.8048 39.4914 12.4332 38.9098Z"
            fill="#3C51A0"
          />
          <path
            d="M13.8248 44.0057C14.5155 44.0057 15.0755 43.4457 15.0755 42.755C15.0755 42.0643 14.5155 41.5044 13.8248 41.5044C13.1341 41.5044 12.5742 42.0643 12.5742 42.755C12.5742 43.4457 13.1341 44.0057 13.8248 44.0057Z"
            fill="#3C51A0"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_496_1330">
          <rect
            width="60"
            height="61"
            fill="white"
            transform="translate(0.0664062 0.758789)"
          />
        </clipPath>
        <clipPath id="clip1_496_1330">
          <rect
            width="60"
            height="61"
            fill="white"
            transform="translate(0.0664062 0.758789)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
